module.exports = __webpack_public_path__ + "static/media/streetfighter.98cd206a.jpg";